import Head from 'next/head'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useDispatch } from 'react-redux'
import { setDashboardTitle } from '@/redux/themeSlice'

import Layout from '../../components/layout-components/homeLayout/Layout'
import AboutUsIntro from '../../components/shared-components/blocks/AboutUsIntro'
import OurValues from '../../components/shared-components/blocks/OurValues'
import AboutUsPoints from '../../components/shared-components/blocks/AboutUsPoints'
import Technology from '../../components/shared-components/blocks/Technology'

const AboutUs = () => {
  const dispatch = useDispatch()
  dispatch(setDashboardTitle('Chi Siamo'))
  return (
    <>
      <Head>
        <title>Smartcaf | Chi Siamo</title>
        <link rel='icon' href='/favicon.ico' />
        <meta
          name='description'
          content="Siamo uniti dalla passione per il servizio e dalla determinazione nel rendere l'assistenza fiscale un'esperienza semplice e conveniente."
        />
      </Head>

      <AboutUsIntro />
      <OurValues />
      <AboutUsPoints />
      <Technology />
    </>
  )
}

AboutUs.Layout = Layout
export default AboutUs

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['HomeLayout'])),
    },
  }
}
